import { attemptStats, exportAttempts } from '../lib/attemptLog.ts';
import type { AppCtx } from './ctx.ts';
import { button, h } from './dom.ts';

/**
 * „Dziennik prób” w ekranie Dla rodzica: tryb testowy (przy każdej próbie pojawiają się przyciski „poprawnie / celowo źle”),
 * licznik opisanych prób i kopiowanie ich do wklejenia w rozmowie. Dane zostają w przeglądarce; kopiowanie to Twoja decyzja.
 */
export function renderAttemptPanel(ctx: AppCtx): HTMLElement {
  const store = ctx.attempts;
  if (!store) return h('div', { class: 'diag-box', hidden: true });

  const info = h('p', { class: 'muted', 'data-testid': 'attempts-count' });
  const status = h('p', { class: 'muted', 'data-testid': 'attempts-status' });
  const text = h('textarea', { class: 'attempts-text', readonly: true, rows: 6, hidden: true, 'data-testid': 'attempts-text', 'aria-label': 'Opisane próby do skopiowania' });
  const toggle = button('', () => {
    store.setTestMode(!store.testMode());
    refresh();
  }, { class: 'btn ghost', testid: 'attempts-toggle' });

  const refresh = () => {
    const s = attemptStats(store.list());
    toggle.textContent = store.testMode() ? '🧪 Tryb testowy: WŁĄCZONY (kliknij, by wyłączyć)' : '🧪 Włącz tryb testowy (opisywanie prób)';
    info.textContent = `Zapisane próby: ${s.total}, opisane: ${s.labelled} (poprawnie ${s.ok}, celowo źle ${s.bad}).`;
  };

  const copy = button('📋 Kopiuj opisane próby', async () => {
    const out = exportAttempts(store.list());
    const n = attemptStats(store.list()).labelled;
    if (n === 0) {
      status.textContent = 'Brak opisanych prób. Włącz tryb testowy, zrób kilka prób w lekcji i przy każdej kliknij, co powiedziałeś.';
      return;
    }
    text.value = out;
    text.hidden = false;
    let copied = false;
    try {
      await navigator.clipboard.writeText(out);
      copied = true;
    } catch {
      /* brak uprawnień do schowka — tekst jest w polu poniżej, zaznacz i skopiuj ręcznie */
    }
    status.textContent = copied ? `Skopiowano ${n} prób. Wklej je w rozmowie z Claude.` : `Nie udało się użyć schowka — zaznacz tekst poniżej (przytrzymaj, „Zaznacz wszystko”) i skopiuj ręcznie (${n} prób).`;
  }, { class: 'btn ghost', testid: 'attempts-copy' });

  const clearBtn = button('🗑 Wyczyść dziennik prób', () => {
    if (!confirm('Usunąć wszystkie zapisane próby z tego urządzenia?')) return;
    store.clear();
    text.hidden = true;
    status.textContent = 'Dziennik wyczyszczony.';
    refresh();
  }, { class: 'btn link danger', testid: 'attempts-clear' });

  refresh();
  return h('div', { class: 'diag-box', 'data-testid': 'attempts-panel' }, toggle, info, copy, status, text, clearBtn);
}
